import { render, staticRenderFns } from "./TestsPlayground.vue?vue&type=template&id=225914f4&"
import script from "./TestsPlayground.vue?vue&type=script&lang=ts&"
export * from "./TestsPlayground.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../backups/absys-worktrees/2026-09-12-colomer-web/src/web/AbsysERP.WebApi/ClientApp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports